import { useEffect, useMemo, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";

let cache = null;
let belofte = null;

/** Gepubliceerde metadata-modules voor het menu van deze gebruiker → extra menu-groepen + hub-mapping (pad → hub). */
export function useDynModules(user) {
  const [items, setItems] = useState(cache || []);
  useEffect(() => {
    if (!user || user.role === "onderaannemer") return;
    if (cache) { setItems(cache); return; }
    belofte = belofte || api.get("/modules/menu").then((r) => { cache = r.data.items || []; return cache; }).catch(() => []);
    belofte.then((it) => setItems(it));
  }, [user]);
  return useMemo(() => {
    const groups = items.length ? [{ cat: "Modules", icon: Icons.Boxes, items: items.map((m) => ({ to: `/m/${m.slug}`, label: m.naam, icon: Icons[m.icoon] || Icons.Box, tid: `nav-m-${m.slug}`, module: "Modules", subgroup: m.groep || "Modules", keywords: [m.slug, "module"] })) }] : [];
    const hubs = Object.fromEntries(items.map((m) => [`/m/${m.slug}`, m.hub]));
    return { groups, hubs, items };
  }, [items]);
}

export function resetDynModulesCache() { cache = null; belofte = null; }
